import { styled } from 'styled-components';

export const Highlighter = styled.span`
    background-color: ${(props) => props.backgroundColor};
    color: #FFFFFF;
    padding:0.3em
`